import clsx from 'clsx'
import React, { FC } from 'react'

interface IRiskProfile {
  name: string
  color: string
}

interface IProps {
  riskProfile?: IRiskProfile
  size: 'small' | 'medium'
}

export const RiskBadge: FC<IProps> = ({ riskProfile, size }) => {
  if (!riskProfile) {
    return <span className='badge badge-light'>Por definir</span>
  }

  return (
    <span
      className={clsx('badge', size === 'medium' && 'p-3')}
      style={{
        color: riskProfile.color,
        background: `${riskProfile.color}1A`,
      }}
    >
      {riskProfile.name}
    </span>
  )
}
